import { ImageToPdfDriver } from '@shared/services/file-export/drivers/imageToPdfDriver';
import {
  TExportFileDriver,
  TFileExportDriversAvailable,
} from '@shared/services/file-export/file-export-interface';

export class ExportFilesFactory {
  public static readonly drivers: TExportFileDriver[] = [
    {
      slug: 'pdf-new',
      icon: 'picture_as_pdf',
      class: ImageToPdfDriver, // New hybrid approach: PDFmake + Mermaid images
    },
  ];

  public static instantiateDriver(slug: TFileExportDriversAvailable) {
    const driver = this.drivers.find(value => value.slug === slug);
    if (!driver) {
      throw new Error(`Driver ${slug} not found`);
    }
    return new driver.class();
  }
}
